export default __webpack_public_path__ + "static/media/blog-heading.09977803.jpg";